import Grid from '@mui/material/Grid';
import { Box, Checkbox } from '@mui/material';
import { Chart } from 'react-google-charts';
import TableComponent from 'widgets/table/component';
import ProductTypesRowsComponent from './TypesRowComponent';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const ChartComponent = ({
  logScale,
  handleCheckboxChange,
  dataType,
  optionsType,
  columnsProductTypes,
  rowsProductType,
}) => {
  return (
    <Grid container>
      <Grid size={{ xs: 12, md: 12 }} mt={3}>
        <Box display='flex' flexDirection='row' alignItems='center' justifyContent='center'>
          <Typography variant='subtitle1'>Escala logarítmica:</Typography>
          <Checkbox checked={logScale} onChange={handleCheckboxChange} label='Enable Log Scale' />
        </Box>
        <Chart
          chartType='ColumnChart'
          width='100%'
          height='auto'
          data={dataType}
          options={optionsType}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 1 }}></Grid>
      <Grid size={{ xs: 12, md: 12 }} mt={4}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls='panel1a-content'
            id='panel1a-header'
          >
            <Typography>Ver Detalle</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <TableComponent
              columns={columnsProductTypes}
              rowsComponent={<ProductTypesRowsComponent rows={rowsProductType} />}
            />
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  );
};

export default ChartComponent;
